import { State } from '../../types'

export function getRequestIsLoading(state: State) {
	return state.Network.isLoading
}
